import cn from "classnames";
import Modal from "../../components/Modal";
import styles from "./ExploreCreators.module.sass";
import ImageInput from "../../components/ImageInput";
import { UseApi } from "../../hooks/use-api";
import { CreateBrand } from "../../Services/lib/brand";
import { useEffect, useState } from "react";
import Loader from "../../components/Loader";
import TextInput from "../../components/TextInput";
import { InputController } from "../../hooks/input-controller";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import Dropdown from "../../components/Dropdown";
import brand_text from "../../i11/brand";
import { useUser } from "../../context";

export const CreateBrandModal = ({
	isOpen,
	onClose,
	fetch: refreshBrand,
	domains,
}) => {
	const { locale } = useUser();
	const [body, setBody] = useState({
		brandname: "",
		taxId: "",
		image: "",
		email: "",
		phoneNumber: "",
		domain: "",
	});
	const brandname = InputController("brandname", setBody);
	const email = InputController("email", setBody);
	const taxID = InputController("taxId", setBody);
	const phoneNumber = InputController("phoneNumber", setBody);
	const [domain, setDomain] = useState("");
	const [imgL, setL] = useState(false);

	const [{ data, isLoading }, fetch] = UseApi({
		service: CreateBrand,
	});

	const saveNewBrand = (e) => {
		e.preventDefault();
		if (imgL) {
			ToastEmitter({
				msg: "Image is uploading, please wait",
				type: "info",
			});
		} else {
			const tmp = { ...body };
			if (tmp.domain.charAt(tmp.domain.length - 1) !== "/") {
				tmp.domain = tmp.domain + "/";
			}
			if (tmp.image.image_list) {
				tmp.image_list = tmp.image.image_list;
				tmp.image = tmp.image.core_image_url;
			}
			fetch(tmp);
		}
	};

	useEffect(() => {
		setBody((p) => {
			return {
				...p,
				domain,
			};
		});
	}, [domain]);

	useEffect(() => {
		if (data) {
			refreshBrand();
			const doc = document.getElementById("my-brand-form");
			doc.reset();
			setBody({
				brandname: "",
				// description: "",
				image: "",
				domain: "",
			});
			ToastEmitter({
				msg: "Congrats, Your new brand is saved",
				type: "success",
			});
			onClose();
		}
	}, [data]);

	const HandleChange = (e) => {
		setBody((p) => {
			return {
				...p,
				image: e,
			};
		});
	};

	return (
		<Modal visible={isOpen} onClose={onClose}>
			<form id="my-brand-form" onSubmit={saveNewBrand}>
				<div
					style={{
						fontSize: "20px",
						fontWeight: "600",
						lineHeight: 1.6,
						letterSpacing: "-.02em",
					}}
				>
					{brand_text[locale].add_b}
				</div>
				<div className={styles.spacer} />
				<TextInput
					className={styles.field}
					label={brand_text[locale].brand_name}
					name="name"
					type="text"
					tooltip="Maximum 100 characters. No HTML or emoji allowed"
					required
					value={body.brandname}
					{...brandname}
				/>
				<div className={styles.spacer} />
				<TextInput
					className={styles.field}
					label={brand_text[locale].brand_email}
					name="name"
					type="email"
					tooltip="Maximum 100 characters. No HTML or emoji allowed"
					required
					value={body.email}
					{...email}
				/>
				<div className={styles.spacer} />
				<TextInput
					className={styles.field}
					label={brand_text[locale].tax_id}
					name="taxID"
					tooltip="Tax identification number"
					required
					value={body.taxID}
					{...taxID}
				/>
				<div className={styles.spacer} />
				<TextInput
					className={styles.field}
					label={brand_text[locale].phone_num}
					name="phoneNumber"
					tooltip="Phone number"
					required
					value={body.phoneNumber}
					{...phoneNumber}
				/>
				<div className={styles.spacer} />

				<Dropdown
					className={cn(styles.field, styles.Dropdown)}
					label={brand_text[locale].domain}
					tooltip="Domain"
					value={domain}
					setValue={setDomain}
					options={domains}
				/>
				<div className={styles.spacer} />
				<div className={styles.spacer} />
				<ImageInput
					where="BRANDS"
					callBack={HandleChange}
					className={styles.field}
					label={brand_text[locale].image}
					required
					tooltip="Image"
					setL={setL}
				/>
				<div className={styles.btns}>
					<button
						type="submit"
						className={cn(`button button-small ${isLoading ? "disabled" : ""}`)}
						style={{ width: "100px" }}
					>
						{isLoading ? (
							<Loader className={styles.loader} white />
						) : (
							brand_text[locale].submit
						)}
					</button>
				</div>
			</form>
		</Modal>
	);
};
